import { render, staticRenderFns } from "./FamRole.vue?vue&type=template&id=9488afb2&scoped=true&"
import script from "./FamRole.vue?vue&type=script&lang=js&"
export * from "./FamRole.vue?vue&type=script&lang=js&"
import style0 from "./FamRole.vue?vue&type=style&index=0&id=9488afb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9488afb2",
  null
  
)

component.options.__file = "FamRole.vue"
export default component.exports